/* eslint-disable @typescript-eslint/no-explicit-any */

import type { BaseErrorResponse, GetWalletBalancesRes } from './data-contracts';
import type { RequestParams } from './http-client';
import { HttpClient } from './http-client';


export default function useWalletBalance() {
  class WalletBalance<SecurityDataType = unknown> extends HttpClient<SecurityDataType> {
    /**
     * No description
     *
     * @tags Wallet
     * @name WalletBalanceControllerGetWalletOperations
     * @summary Returns wallet balances
     * @request GET:/api3/wallet-balance
     * @secure
     * @response `200` `GetWalletBalancesRes`
     * @response `400` `BaseErrorResponse`
     */
    walletBalanceControllerGetWalletOperations = (
      query: {
        /**
         * @min 1
         * @max 500
         * @example 10
         */
        limit: number;
        /**
         * @min 0
         * @example 0
         */
        page: number;
        /** @example 3 */
        walletTypeId?: number;
        /** @example 1 */
        accountId?: number;
        filter: any;
        orderBy: any;
      },
      params: RequestParams = {},
    ) =>
      this.request<GetWalletBalancesRes, BaseErrorResponse>({
        path: '/api3/wallet-balance',
        method: 'GET',
        query,
        secure: true,
        format: 'json',
        ...params,
      });
  }

  return new WalletBalance();
}
